export default "__VITE_ASSET__DdaNv7Eh__"